<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">联系我们</div>
    <div class="title-sub">
      手机：173-1718-1516<br><br>
      微信号：sino-sh<br><br>
      地址： 上海市静安区沪太支路538弄5i飞马旅D1栋419室<br><br>
      欢迎您来电咨询，我们将竭诚为您服务。
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        // width: 1039px;
        color: #666;
        transform: .5s;
        line-height: 24px;
        // text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
    }
}
</style>
